import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home-header__in" }
const _hoisted_2 = { class: "home-header__head" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "home-header__title" }, "Total Balance", -1)
const _hoisted_4 = {
  class: "home-header__balance",
  "data-currency": "USDT"
}
const _hoisted_5 = { class: "home-header__footer" }
const _hoisted_6 = { class: "home-header__referals" }
const _hoisted_7 = {
  class: "home-header__referrals-profit",
  "data-currency": "USDT"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "home-header__referrals-hint" }, "Received by referrals", -1)
const _hoisted_9 = {
  class: "section section--mini",
  style: {"padding-left":"0"}
}
const _hoisted_10 = { class: "home-info section section--mini" }
const _hoisted_11 = { class: "home-info__row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "home-info__title" }, "Bot status:", -1)
const _hoisted_13 = { class: "home-info__row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "home-info__title" }, "Actual price:", -1)
const _hoisted_15 = {
  class: "home-info__value home-info__course",
  "data-currency": "USDT/BTC"
}
const _hoisted_16 = { class: "home-controls section section--mini" }

import "./HomeView.scss";
import Hat from "@/components/Hat/Hat.vue";
import Button from "@/components/Button/Button.vue";
import Icon from "@/components/Icon/Icon.vue";
import AnalyticChart from "@/components/AnalyticChart/AnalyticChart.vue";
import {RouterLink, useRouter} from "vue-router";
import {useUserStore} from "@/stores/userStore";
import {onMounted, ref} from "vue";
import {useApiStore} from "@/stores/apiStore";
import {storeToRefs} from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

let userStore = useUserStore();
let {api} = useApiStore();
let router = useRouter();

let {me} = storeToRefs(userStore);

let course = ref<number>(0);
let referrals_profit = ref<number>(0);

async function start(){

	if(me.value!.balance > 0){
		await api.startTrading();
	}else{
		await router.push('/wallet/top-up');
	}

}

async function stop(){
	await api.stopTrading();
}

onMounted(async () => {
	course.value = +await api.getCourse();
	referrals_profit.value = (await api.getStatistic()).referrals.amount;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Hat, { class: "screen-start section section--mini home-header" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(me).balance.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(Button, {
              color: "brand",
              size: "small",
              is: _unref(RouterLink),
              to: "/wallet/top-up"
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, {
                  name: "plus",
                  size: 1.25
                }),
                _createTextVNode("       Top up ")
              ]),
              _: 1
            }, 8, ["is"]),
            _createVNode(Button, {
              color: "light",
              size: "small",
              is: _unref(RouterLink),
              to: "/wallet/withdrawal"
            }, {
              default: _withCtx(() => [
                _createVNode(Icon, { name: "up" }),
                _createTextVNode(" Withdraw ")
              ]),
              _: 1
            }, 8, ["is"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(referrals_profit).toFixed(2)), 1),
          _hoisted_8
        ])
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_9, [
      _createVNode(AnalyticChart)
    ]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("p", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("span", {
          class: _normalizeClass(["home-info__value home-info__status", {
				'home-info__status--active' : _unref(me).is_trading_enabled,
				'home-info__status--disabled' : !_unref(me).is_trading_enabled
			}])
        }, _toDisplayString(_unref(me).is_trading_enabled ? 'Active' : 'Not active'), 3)
      ]),
      _createElementVNode("p", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(course).toFixed(2)), 1)
      ])
    ]),
    _createElementVNode("section", _hoisted_16, [
      _createVNode(Button, {
        color: "brand-transparent",
        type: "button",
        onClick: start,
        disabled: _unref(me).is_trading_enabled
      }, {
        default: _withCtx(() => [
          _createVNode(Icon, { name: "rocket" }),
          _createTextVNode(" Start ")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(Button, {
        color: "red-transparent",
        type: "button",
        onClick: stop,
        disabled: !_unref(me).is_trading_enabled
      }, {
        default: _withCtx(() => [
          _createVNode(Icon, {
            name: "close",
            size: 1.5
          }),
          _createTextVNode(" Stop ")
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(Button, { color: "dark" }, {
        default: _withCtx(() => [
          _createVNode(Icon, { name: "support" }),
          _createTextVNode(" Channel ")
        ]),
        _: 1
      }),
      _createVNode(Button, { color: "dark" }, {
        default: _withCtx(() => [
          _createVNode(Icon, { name: "support" }),
          _createTextVNode(" Chat ")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})